/*
 * @Author: xinxu
 * @Date: 2023-07-10 09:58:02
 * @LastEditors: xinxu
 * @LastEditTime: 2023-07-11 18:59:24
 * @FilePath: /FX-AI-website/src/constant/secret.ts
 */
export const FETCH_SECRET_KEY = '灵树树ePIVsMBy5LHQGtgtShrI7Q7depvEdl';

// 请求平台标识，后端根据不同平台可能有不同的鉴权逻辑或权限控制
export const PLATFORM = 'web';
